import * as React from 'react';

export interface ISwipeAreaProps {
    /** The minimum distance (in pixels) the user must swipe for the swipe to be recognized */
    intentThreshold?: number;
    /** The minimum distance (in pixels) the user must swipe for the swipe to be recognized and trigger the onSwipeLeft or onSwipeRight callback */
    swipeThreshold?: number;
    onSwipeLeft: () => void;
    onSwipeRight: () => void;
}

const SwipeArea: React.FC<ISwipeAreaProps> = ({
    intentThreshold = 10,
    swipeThreshold = 50,
    onSwipeLeft,
    onSwipeRight,
    children
}) => {
    const touchStartXRef = React.useRef<number | null>(null);
    const touchCurrentXRef = React.useRef<number | null>(null);

    const handleTouchStart = (e: React.TouchEvent) => {
        touchStartXRef.current = e.touches[0].clientX;
        touchCurrentXRef.current = e.touches[0].clientX;
    };

    const handleTouchMove = (e: React.TouchEvent) => {
        touchCurrentXRef.current = e.touches[0].clientX;
    };

    const handleTouchEnd = () => {
        if (touchStartXRef.current === null || touchCurrentXRef.current === null) {
            return;
        }
        const deltaX = touchCurrentXRef.current - touchStartXRef.current;

        if (Math.abs(deltaX) < intentThreshold) {
            // Not a valid swipe, ignore
            return;
        }
        if (deltaX > swipeThreshold) {
            onSwipeRight();
        } else if (deltaX < -swipeThreshold) {
            onSwipeLeft();
        }
        // Reset refs
        touchStartXRef.current = null;
        touchCurrentXRef.current = null;
    };

    return (
        <div
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
            style={{ touchAction: 'pan-y' }} // Allow vertical scrolling while swiping horizontally
        >
            {children}
        </div>
    );
};

export default SwipeArea;